import { ajax as request } from '@blade/common';
/**
 * @description: 上传用户头像
 * @param {type}
 * @return {type}
 */
export const uploadAvatar = (data) => request({
    url: '/api/user-management/api/v1/ums/user/avatar',
    method: 'POST',
    data
});
export const checkPassword = (data) => request({
    url: '/api/user-management/api/v1/ums/user/password',
    method: 'POST',
    data
});
/**
 * @description: 获取消息开关
 * @param {type}
 * @return {type}
 */
export const msgSetting = () => request({
    url: '/api/user-management/api/v1/ums/user/msg/setting',
    method: 'GET',
});
/**
 * @description: 更改消息开关
 * @param {type}
 * @return {type}
 */
export const changeSetting = (enable, type) => request({
    url: '/api/user-management/api/v1/ums/user/msg/setting',
    method: 'POST',
    data: {
        enable,
        type
    }
});
export const userInfo = (data) => request({
    url: '/api/user-management/api/v1/ums/user',
    method: 'PATCH',
    data
});
/**
 * @description: 查询用户隐私
 * @param {type}
 * @return {type}
 */
export const userPrivacy = () => request({
    url: `/api/user-management/api/v1/ums/user/privacy`,
    method: 'GET',
});
export const userPrivacyConfig = (data) => request({
    url: `/api/user-management/api/v1/ums/user/privacy/config`,
    method: 'POST',
    data
});
